import * as React from 'react';
import { Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const MonthlyPrice = ({ currency , price , labels  })=>/*#__PURE__*/ React.createElement("div", {
        className: "contact-lens-configurator__monthly-price"
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Price, {
        value: price.centAmount,
        currency: currency,
        className: "contact-lens-configurator__pack-size-price"
    }), ' / ', /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        component: "span"
    }, labels.perMonth)))
;

export { MonthlyPrice as default };
//# sourceMappingURL=MonthlyPrice.js.map
